import React from 'react'
import styled from 'styled-components'
import { P, H4 } from '../../../typography'

const Wrapper = styled.div`
  margin-bottom: 40px;
`

const Heading = styled(H4)`
  font-weight: 500;
`

const TextWithHeading = ({ heading, paragraphs }) => (
  <Wrapper>
    <Heading>{heading}</Heading>

    {paragraphs && paragraphs.map(paragraph => <P key={paragraph.substring(0, 10)}>{paragraph}</P>)}
  </Wrapper>
)

export default TextWithHeading
